//项目根组件

import { Component, useEffect } from "react";
import { HashRouter as Router, Redirect, Route, Switch } from "react-router-dom"
import Login from "./pages/login/login"
import Admin from "./pages/admin/admin"
import store from "./utils/storeUtils"
import memory from "./utils/memoryUtils"

const App = () => {
  memory.company_info=store.getCompanyInfo()
  return (
    <Router>
      <Switch>
        <Route path="/login" component={Login}></Route>
        <Route path="/" component={Admin}></Route>
      </Switch>
    </Router>
  )

}


export default App